import React, { useCallback, useEffect, useState } from "react";
import { DashboardLayout } from "../../components/DashboardLayout";
import api from "../../lib/api";
import { ClipboardList, Filter } from "lucide-react";
import { links } from "./SuperAdminPages";

export function SuperAdminEncountersPage() {
  const [clinics, setClinics] = useState([]);
  const [selectedClinic, setSelectedClinic] = useState("");
  const [encounters, setEncounters] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/admin/clinics").then(r => setClinics(r.data));
  }, []);

  const fetchEncounters = useCallback(async () => {
    if (!selectedClinic) {
      setEncounters([]);
      return;
    }
    setLoading(true);
    try {
      const r = await api.get(`/admin/encounters?clinic_id=${selectedClinic}`);
      setEncounters(r.data);
    } catch (e) { }
    setLoading(false);
  }, [selectedClinic]);

  useEffect(() => {
    fetchEncounters();
  }, [fetchEncounters]);

  return (
    <DashboardLayout links={links} title="Platform Encounters">
      <div className="mg-card mb-6">
        <h3 className="font-bold text-mg-navy mb-4 flex items-center gap-2">
          <Filter className="w-4 h-4"/> Select Clinic Context
        </h3>
        <select 
          className="mg-input w-full max-w-md" 
          value={selectedClinic} 
          onChange={e => setSelectedClinic(e.target.value)}
        >
          <option value="">-- Choose a clinic to view encounters --</option>
          {clinics.map(c => (
             <option key={c.clinic_id} value={c.clinic_id}>{c.name}</option>
          ))}
        </select>
        {!selectedClinic && <p className="text-xs text-amber-600 mt-2">Clinic filter is required to view encounters.</p>}
      </div>

      {selectedClinic && (
        <div className="mg-card">
          {loading ? (
            <div className="py-8 text-center text-slate-400">Loading...</div>
          ) : (
            <table className="w-full text-sm">
              <thead className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-slate-100">
                <tr><th className="py-3">Date</th><th>Patient</th><th>Doctor</th><th>Status</th></tr>
              </thead>
              <tbody>
                {encounters.map(e => (
                  <tr key={e.encounter_id} className="border-b border-slate-50">
                    <td className="py-3">{new Date(e.encounter_datetime).toLocaleDateString()}</td>
                    <td>{e.patient?.name || "Unknown"}</td>
                    <td>{e.doctor?.name || "Unknown"}</td>
                    <td><span className={`mg-status mg-status-${e.status.toLowerCase().replace(/\s+/g, "-")}`}>{e.status}</span></td>
                  </tr>
                ))}
                {encounters.length === 0 && <tr><td colSpan="4" className="text-center py-8 text-slate-400">No encounters found for this clinic.</td></tr>}
              </tbody>
            </table>
          )}
        </div>
      )}
    </DashboardLayout>
  );
}
